import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PermisosListSelect from "../Permisos/PermisosListSelect.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import UserFormSections from "./UserFormSections.js"

import { TabContent, TabPane, Nav, NavItem, NavLink, Label } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            grupo_id: null,
            permisos_checked: [],
            permisos_disabled: [],
            departamento_id: null,
            departamentopadre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }


    ResetForm() {
        this.setState({
            activeTab: 1,
            grupo_id: null,
            permisos_checked: [],
            permisos_disabled: [],
            departamento_id: null,
            departamentopadre_id: null,
        });
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    groupChanged(value) {
        if (value) {
            this.setState({
                grupo_id: value.pk,
                permisos_disabled: value.permisos,
                permisos_checked: [],
            });
        } else {
            this.setState({
                grupo_id: null,
                permisos_disabled: [],
                permisos_checked: [],
            });
        }
    }



    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.usuarios.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Usuario ha sido creado con éxito."}
                title={"Nuevo Usuario"}
                buttonTitle={"Nuevo Usuario"}
                buttonIcon={"fa fa-plus fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}

                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
            >
                <div className="ui-form">
                <Nav tabs>
                    <NavItem>
                        <NavLink className={this.getActiveClass(1)} onClick={() => { this.toggleTab(1); }}>
                            Usuario
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={this.getActiveClass(2)} onClick={() => { this.toggleTab(2); }}>
                            Permisos
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <UserFormSections
                            autoFocusFirstField={true}
                            includePassword={true}
                            departamentoId={this.state.departamento_id}
                            departamentoPadreId={this.state.departamentopadre_id}
                            onGrupoChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                            onSubgrupoChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                        />
                    </TabPane>
                    <TabPane tabId={2}>
                        <section className="ui-section-block">
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Perfil de Usuario</Label>
                                    <ParadigmaAsyncSeeker onChange={(value) => this.groupChanged(value)} fieldName={"grupo_id"}
                                        url={api.usuarios.perfiles.select} value={this.state.grupo_id} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Permisos</Label>
                                    <PermisosListSelect disabledNodes={this.state.permisos_disabled} onChange={(value) => this.setState({ permisos_checked: value })} checked={this.state.permisos_checked} fieldName={"permisos"} />
                                </div>
                            </div>
                        </section>
                    </TabPane>
                </TabContent>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Create.js